module.exports = __webpack_public_path__ + "img/map-decor.4e0d97b7.png";